<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading = "loading"
      :page.sync="page"
      :data="data"
      id="parkParkingSpace"
      ref="crud"
      @on-load="onLoad"
      @search-change="searchChange"
      @selection-change="selectionChange"
      @refresh-change="onLoad"
      >
      <template slot="menuLeft">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="openAddForm('add')"
        >新  增
        </el-button>
        <el-button
          size="small"
          icon="el-icon-sort"
          :loading = "syncButtonLoading"
          @click="handleSync">同步
        </el-button>
      </template>
      <template slot="menu" slot-scope="scope">
<!--        <el-button type="text" size="small" @click="toView(scope.row)">
          <span class="el-icon-view"></span>查看
        </el-button>-->
        <el-button type="text" size="small" icon="el-icon-edit" @click="toEdit(scope.row,'edit')">编辑</el-button>
        <el-button type="text" size="small" icon="el-icon-delete" style="padding-left: 10px; color: red" @click="handleDelete(scope.row)">删除</el-button>
      </template>
    </avue-crud>
    <avue-form v-if="showForm" ref="parkRegionForm" v-model="form" :rules="rules" :option="option" @reset-change="emptyChange" @submit="submit">
      <template slot-scope="scope" slot="menuForm">
        <el-button @click="emptyChange" icon="el-icon-delete">清空</el-button>
      </template>
    </avue-form>
  </basic-container>
</template>

<script>
  import {
    getTreeChildrenCarParkNode,
    getList,
    addParkSpaceNode,
    getDetailById,
    update,
    updateCarSpace,
    addPark,
    remove,
    syncParkPositions,
  } from '@/api/v4ward/car/carpark';
  import {getRegionList,numberCheck,stringCheck,getPassages} from '@/views/v4ward/car/merge/api/park-merge';
  import { mapGetters } from 'vuex';
  import {forEach} from "lodash/fp/_util";
  export  default {
    props: {
      parkSpace: {},
    },
    data() {
      var checkSpaceCode = (rule, value, callback) => {
        if(this.operateType === 'edit'){
          if(value.includes(',')||value.includes('，')){
            callback(new Error('修改时不能输入多个车位编号！'));
          }else if(value.length > 20){
            callback(new Error('车位编号长度不能超过20！'));
          }else{
            callback();
          }
        }else{
          if(value.includes(',')||value.includes('，')){
            value = value.replace(/，/g,',');
            let spaces = value.split(',');
            spaces.forEach(e=>{
              if(e.length > 20){
                callback(new Error('存在车位编号长度不能超过20！'));
                return;
              }
            });
            callback();
          }else if(value.length > 20){
            callback(new Error('车位编号长度不能超过20！'));
          }else{
            callback();
          }
        }
      };
      return{
        syncButtonLoading: false,
        loading: false,
        showForm: false,
        operateType: '',
        selectionList:[],
        query: {},
        page: {
          pageSize: 8,
          currentPage: 1,
          total: 0,
          pageSizes :[8],
        },
        form: {},
        option: {
          calcHeight: 350,
          rowHeight: 20,
          tip: false,
          border: true,
          index: false,
          selection: true,
          columnBtn: false,
          viewBtn: false,
          addBtn: false,
          editBtn: false,
          delBtn: false,
          emptyBtn: false,
          menuType: 'text',
          refreshBtn:false,
          align: 'center',
          menuWidth: 200,
          searchMenuSpan: 6,
          column: [
            {
              label: '所属区域',
              prop: 'parentId',
              type: 'tree',
              dicData: [],
              //row: true,
              dataType: 'string',
              dicUrl: '/api/v4ward/car/parkSpaceNode/nodeTreeByParentId?parentId=' + this.parkSpace.id,
              props: {
                label: 'title',
                value: 'id',
                disabled: 'disabled',
              },
              rules: [
                {
                  required: true,
                  message: '请选择区域',
                  trigger: 'change',
                },
              ],
            },
            {
              label: '车位状态',
              prop: 'carParkStatus',
              search: true,
              type: 'select',
              disabled: true,
              dicUrl: 'api/blade-system/dict/dictionaryWithIntKey?code=car_park_status',
              props: { label: 'dictValue', value: 'dictKey' },
            },
            {
              label: '车位编号',
              prop: 'spaceName',
              search: true,
              type: 'textarea',
              minRows: 2,
              span: 24,
              placeholder: '多个车位使用英文逗号隔开',
              hide: false,
              rules: [{
                required: true,
                trigger: 'blur',
                message: '请输入车位编号'
              },{
                validator: checkSpaceCode,
                trigger: 'blur',
              },]
            },
          ]
        },
      }
    },
    computed: {
      ...mapGetters(['permission']),
      permissionList() {
        return {
          addBtn: this.vaildData(this.permission.parkpassage_add, false),
        };
      },
      ids() {
        let ids = [];
        this.selectionList.forEach((ele) => {
          ids.push(ele.id);
        });
        return ids.join(',');
      },
    },
    created() {
      setTimeout(() =>{
        document.querySelector("#pane-parkParkingSpace > div > div > div").style='padding-top:0px !important';
      });
    },
    mounted() {},
    methods: {
      handleDelete(row) {
        remove({ ids: row.id }).then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
      },
      handleSync() {
        if (this.selectionList.length === 0) {
          this.$message.warning('请选择至少一条数据');
          return;
        }
        this.syncButtonLoading = true;
        syncParkPositions({ ids: this.ids }).then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.syncButtonLoading = false;
          this.$refs.crud.toggleSelection();
        });
      },
      openAddForm(operateType){
        this.operateType = operateType;
        this.cleanForm();
        this.showForm = !this.showForm;
      },
      toEdit(row,operateType){
        this.operateType = operateType;
        this.showForm = !this.showForm;
        this.form = row;
      },
      searchChange(params, done) {
        this.query = params;
        this.page.currentPage = 1;
        this.onLoad();
        done();
      },
      onLoad(page){
        page = page || this.page;
        this.loading = true;
        getList(Object.assign(
          {current: page.currentPage, size: page.pageSize, parentId: this.query.parentId, parkId: this.parkSpace.id },
          this.query)).then(({ data }) =>{
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
          }
        )
      },
      selectionChange(list) {
        this.selectionList = list;
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      emptyChange(){
        if(this.operateType === 'add'){
          this.cleanForm();
        }else {
          this.$message.warning('编辑时清空无效！');
        }
      },
      submit (form,done) {
        console.log('++++++');
        this.form.type = 4;
        this.form.parkSpaceNo = this.form.spaceName;
        if(this.vdui.isEmpty(form.id)){
          this.form.parkingLotId = this.parkSpace.id;
          this.form.parkId = this.parkSpace.id;
          this.form.carParkStatus = 0;
          this.form.tempParkFlag = 0;
          addPark(this.form).then(() => {
              done();
              this.$message.success('操作成功!');
              this.cleanForm();
              this.onLoad();
              this.showForm = false;
          },(error) => {
            done();
            console.log(error);
          });
        }else{
          updateCarSpace(this.form).then(() => {
              done();
              this.$message.success('操作成功!');
              this.cleanForm();
              this.onLoad();
              this.showForm = false;
            },
            (error) => {
              done();
              console.log(error);
            }
          );
        }
      },
      cleanForm() {
        for(let key in this.form){
            this.form[key] = '';
        }
        this.form.carParkStatus = 0;
      },
    },



  }


</script>
<style scoped>
  #parkParkingSpace .el-table--small td, .el-table--small th {
    padding: 0 !important;
  }
</style>
